"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _pageHeader = require("../styles/pageHeader"),
    _vars = require("../../../common/styles/vars"),
    _TitleBox = _interopRequireDefault(require("../../TitleBox")),
    _Button = _interopRequireDefault(require("../../Button")),
    _ActionPopup = _interopRequireDefault(require("../../ActionPopup"));

require("../styles/_page-header.scss");

function PageHeader(a) {
  var b = a.title,
      c = a.breadCrumbs,
      d = a.titlePlaceHolder,
      e = a.subtitle,
      f = a.subtitleLink,
      g = a.actionBtnText,
      h = a.actionBtnMobileIcon,
      i = a.actionBtnOnClick,
      j = a.secondaryContent,
      k = a.editableTitle,
      l = a.onBlurTitle,
      m = a.onChangeTitle,
      n = a.actionBtnBusy,
      o = a.titleIconColor,
      p = a.alwaysShowSubtitle,
      q = a.actionPopupOptions,
      r = a.darkMode,
      s = a.size,
      t = a.titleSuffixIcon,
      u = a.history,
      v = a.loading,
      w = a.titleSuffix,
      x = s.width && s.width < _vars.NUMERIC_MEDIA_SIZES.small;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("column", "page-header", (0, _pageHeader.PAGE_HEADER)({
      darkMode: r
    }))
  }, _react["default"].createElement(_TitleBox["default"], {
    title: b,
    breadCrumbs: c,
    titlePlaceHolder: d,
    subtitle: e,
    subtitleLink: f,
    editableTitle: k,
    onBlurTitle: l,
    onChangeTitle: m,
    titleIconColor: o,
    alwaysShowSubtitle: p,
    darkMode: r,
    titleSuffixIcon: t,
    history: u,
    loading: v,
    titleSuffix: w
  }), !v && _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_pageHeader.ACTION_CONTENT, "page-header__action-content")
  }, j, g && _react["default"].createElement(_Button["default"], {
    key: "page-header-action-mob",
    className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, _pageHeader.ACTION_BTN_MOBILE, x), "page-header__action-button"),
    onClick: i,
    busy: n,
    prefix: x ? h : void 0
  }, x ? null : g), q ? _react["default"].createElement(_ActionPopup["default"], {
    options: q
  }) : null));
}

PageHeader.displayName = "PageHeader", PageHeader.defaultProps = {
  actionBtnMobileIcon: "addfat",
  secondaryContent: null,
  editableTitle: !1
};

var _default = (0, _react.memo)(PageHeader);

exports["default"] = _default;